// require('amfe-flexible');
require('../assets/clamp/clamp');
require('../../modules/fixed_side/fixed_side')
require('../../modules/fixed_banner/fixed_banner')

import plyr from 'plyr';
import $ from 'jquery';
import UAParser from 'ua-parser-js';
import imgReady from './utils/imgReady';
import { sendWebSiteInfo } from './utils/sendWebsiteInfo'; // 上报统计

if (UAParser().device.type !== 'mobile') {
  document.documentElement.classList.add('not-mobile');
}

var forEach = function (el, cb) {
  return Array.prototype.forEach.call(el, cb)
}

// 文字多行截断
Array.prototype.forEach.call(
  document.querySelectorAll('[data-clamp]'),
  function (el) {
    $clamp(el, { clamp: el.getAttribute('data-clamp') });
  }
);


// 九宫格图片设置横向或竖向
Array.prototype.forEach.call(
  document.querySelectorAll('[data-direction]'),
  function (el) {
    const img = el.querySelector('img');
    const value = Number(el.getAttribute('data-direction-value')) || 1.25
    const imgUrl = img.getAttribute('src');

    imgReady(imgUrl, function () {
      if ((this.width / this.height) > value) {
        el.setAttribute('data-direction', 'horizontal');
      } else {
        el.setAttribute('data-direction', 'vertical');
      }
    })
  }
);

// 视频初始化
var player = plyr.setup('.player', {
  controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
});

// facebook分享
forEach(document.querySelectorAll('#fb-share'), function (el) {
  el.addEventListener('click', function () {
    FB.ui(
      {
        method: 'share',
        href: document
          .querySelector('[property="og:url"]')
          .getAttribute('content')
      },
      function (res) {
        console.log(res);
      }
    );
  });
});

// 文章内容显示半屏
var setHalfArticle = function () {
  var articleContent = document.querySelectorAll('.spread')
  var windowHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight
  );

  forEach(articleContent, function (el) {
    var article = el.previousElementSibling
    var wrap = el.parentElement
    var articleHeight = article.clientHeight
    var spread = el

    if (articleHeight > windowHeight) {
      wrap.classList.add('relative')
      article.classList.add('is-collapsed')
    }
    spread && spread.querySelector('.icon-spread').addEventListener('click', function () {
      document.querySelector('.modal-down').classList.remove('hide');
    })
  })
}

$(function() {

  const version = $('meta[name="version"]').attr("content");

  setHalfArticle()

  sendWebSiteInfo({
    event: "view_page",
    version: version
  });

  $('[data-pos]').on("click", function() {
    console.log($(this).attr("data-pos"))
    sendWebSiteInfo({
      event: "click_download",
      pos: $(this).attr("data-pos"),
      version: version
    })
  })

  $(".modal-btn-cancel").on("click", function() {
    $(".modal-down").addClass("hide");
    $(".section-content").removeClass("is-collapsed");
  })

})



// WEBPACK FOOTER //
// ./vn_share.js